import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex flex-col min-h-screen" data-id="element-111">
      <Navbar data-id="element-112" />
      <main className="flex-grow" data-id="element-113">{children}</main>
      <Footer data-id="element-114" />
    </div>;
}